
import { config } from "config"
import { options } from "utils";

export const getComprobantesSinCAE = async (q = '') => {
  const url = `${config.URL_API_PRIVATE}/comprobantes/sincae?${q}`;
  const response = await fetch(url, options("GET"));
  return response.json();
};

export const autorizarCAEMasivo = async (body) => {
  const url = `${config.URL_API_PRIVATE}/autorizarcae/masivo`;
  const response = await fetch(url, options("POST", body));
  return response.json();
};